<template>
  <div class="sidebar__link-wrapper">
    <router-link to="/academy-teacher-list" class="sidebar__link">
      <UserIcon class="w-5 h-5" />
      <p>{{ $t("Sidebar.mentors-tutors") }}</p>
    </router-link>
  </div>
  <div class="sidebar__link-wrapper">
    <router-link to="/teacher-statistics" class="sidebar__link">
      <ChartBarIcon class="w-5 h-5" />
      <p>{{ $t("Sidebar.rating") }}</p>
    </router-link>
  </div>
  <div class="sidebar__link-wrapper">
    <router-link to="/teachers-lessons-schedule" class="sidebar__link">
      <CalendarDaysIcon class="w-5 h-5" />
      <p>{{ $t("Sidebar.schedule") }}</p>
    </router-link>
  </div>

  <div class="sidebar__link-wrapper">
    <router-link to="/admin-groups" class="sidebar__link">
      <UsersIcon class="w-6 h-6" />
      <p>{{ $t("Sidebar.groups-list") }}</p>
    </router-link>
  </div>

  <div class="sidebar__link-wrapper">
    <router-link to="/academy-nabors" class="sidebar__link">
      <UserGroupIcon class="w-5 h-5" />
      <p>{{ $t("Statistics.nabor-short") }}</p>
    </router-link>
  </div>

  <div class="sidebar__link-wrapper">
    <router-link to="/academy-courses" class="sidebar__link">
      <BookOpenIcon class="w-5 h-5" />
      <p>Kurslar</p>
    </router-link>
  </div>
  <div class="sidebar__link-wrapper">
    <router-link to="/attendance-statistics" class="sidebar__link">
      <ClipboardDocumentCheckIcon class="w-5 h-5" />
      <p>Davomatlar</p>
    </router-link>
  </div>
  <div class="sidebar__link-wrapper">
    <router-link to="/it-support-log" class="sidebar__link">
      <ShieldCheckIcon class="w-5 h-5" />
      <p>IT Support log</p>
    </router-link>
  </div>
  <div class="sidebar__link-wrapper">
    <router-link to="/admin-ai-usage" class="sidebar__link">
      <CpuChipIcon class="w-5 h-5" />
      <p>AI Usage</p>
    </router-link>
  </div>
  <div v-if="hasHeadAccess" class="sidebar__link-wrapper">
    <router-link to="/statistics" class="sidebar__link">
      <ChartBarIcon class="w-5 h-5" />
      <p>Статистика</p>
    </router-link>
  </div>
  <div v-if="hasHeadAccess" class="sidebar__link-wrapper">
    <router-link to="/events" class="sidebar__link">
      <CalendarDaysIcon class="w-5 h-5" />
      <p>{{ t("Sidebar.events") }}</p>
    </router-link>
  </div>
  <div class="sidebar__link-wrapper">
    <router-link to="/academy-surveys" class="sidebar__link">
      <ClipboardDocumentListIcon class="w-5 h-5" />
      <p>{{ $t("Surveys.title") }}</p>
    </router-link>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import {
  UserIcon,
  ChartBarIcon,
  CalendarDaysIcon,
  BookOpenIcon,
  UsersIcon,
  UserGroupIcon,
  ClipboardDocumentCheckIcon,
  ShieldCheckIcon,
  CpuChipIcon,
  ClipboardDocumentListIcon,
} from "@heroicons/vue/24/outline";
import { storageGet, STORAGE_KEYS } from "@/services/storage.service";

const { t } = useI18n();
const hasHeadAccess = computed(
  () =>
    !!storageGet(STORAGE_KEYS.SUPER_USER) ||
    storageGet(STORAGE_KEYS.HEAD_ACCESS) === "true"
);
</script>
